import React, { useState } from 'react';
import { User, Building2, Bell, ChevronRight, Camera, Check, Save } from 'lucide-react';
type Section = 'profilo' | 'proprieta' | 'notifiche';
export function HostSettingsPage() {
  const [activeSection, setActiveSection] = useState<Section>('profilo');
  // Profile State
  const [profile, setProfile] = useState({
    firstName: 'Marco',
    lastName: 'Rossi',
    email: 'marco.rossi@email.com',
    phone: '+39 06 1234567',
    company: 'Rossi Properties SRL',
    vat: 'IT98765432101'
  });
  // Default Properties State
  const [checklist, setChecklist] = useState([{
    id: 1,
    label: 'Cambio biancheria',
    checked: true
  }, {
    id: 2,
    label: 'Pulizia bagni',
    checked: true
  }, {
    id: 3,
    label: 'Aspirapolvere',
    checked: true
  }, {
    id: 4,
    label: 'Cucina e elettrodomestici',
    checked: true
  }, {
    id: 5,
    label: 'Rifornimento kit cortesia',
    checked: true
  }]);
  const [accessInstructions, setAccessInstructions] = useState('');
  // Notifications State
  const [notifications, setNotifications] = useState({
    newRequests: true,
    updates: true,
    weeklyReport: false
  });
  const handleProfileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setProfile({
      ...profile,
      [e.target.name]: e.target.value
    });
  };
  const toggleChecklist = (id: number) => {
    setChecklist(checklist.map(item => item.id === id ? {
      ...item,
      checked: !item.checked
    } : item));
  };
  const toggleNotification = (key: keyof typeof notifications) => {
    setNotifications(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };
  const handleSave = () => {
    alert('Modifiche salvate con successo!');
  };
  const navItems = [{
    id: 'profilo',
    label: 'Profilo',
    icon: User
  }, {
    id: 'proprieta',
    label: 'Proprietà Default',
    icon: Building2
  }, {
    id: 'notifiche',
    label: 'Notifiche',
    icon: Bell
  }];
  return <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-627">
      {/* Header */}
      <header data-id="element-628">
        <h1 className="text-xl lg:text-2xl font-bold font-montserrat text-navy mb-1" data-id="element-629">
          Impostazioni
        </h1>
        <p className="text-sm text-gray-500" data-id="element-630">
          Gestisci il tuo profilo e le preferenze dell'account
        </p>
      </header>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-631">
        {/* Sidebar Navigation */}
        <div className="lg:col-span-1 space-y-4" data-id="element-632">
          <div className="bg-white border border-gray-200 rounded-xl overflow-hidden sticky top-24" data-id="element-633">
            <nav className="p-2 space-y-1" data-id="element-634">
              {navItems.map(item => {
              const Icon = item.icon;
              const isActive = activeSection === item.id;
              return <button key={item.id} onClick={() => setActiveSection(item.id as Section)} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? 'bg-teal-50 text-teal-deep' : 'text-gray-600 hover:bg-gray-50 hover:text-navy'}`} data-id="element-635">
                    <Icon size={18} data-id="element-636" />
                    {item.label}
                    {isActive && <ChevronRight size={16} className="ml-auto text-teal-deep/50" data-id="element-637" />}
                  </button>;
            })}
            </nav>
          </div>
        </div>

        {/* Main Content Area */}
        <div className="lg:col-span-2 space-y-6" data-id="element-638">
          {activeSection === 'profilo' && <div className="bg-white border border-gray-200 rounded-xl p-6" data-id="element-639">
              <h2 className="text-lg font-bold text-navy mb-6" data-id="element-640">
                Profilo Personale
              </h2>

              {/* Avatar Section */}
              <div className="flex items-center gap-4 mb-8" data-id="element-641">
                <div className="relative group cursor-pointer" data-id="element-642">
                  <div className="w-20 h-20 rounded-full bg-teal-100 border-2 border-teal-200 flex items-center justify-center text-teal-deep text-xl font-bold" data-id="element-643">
                    MR
                  </div>
                  <div className="absolute inset-0 bg-black/40 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-644">
                    <Camera className="text-white w-6 h-6" data-id="element-645" />
                  </div>
                </div>
                <div data-id="element-646">
                  <h3 className="text-base font-bold text-navy" data-id="element-647">Marco Rossi</h3>
                  <p className="text-xs text-gray-500 mb-1" data-id="element-648">Host</p>
                  <button className="text-sm font-medium text-teal-deep hover:text-teal-700 transition-colors" data-id="element-649">
                    Cambia foto
                  </button>
                </div>
              </div>

              {/* Form Fields */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-650">
                <div className="space-y-1.5" data-id="element-651">
                  <label className="text-sm font-medium text-gray-700" data-id="element-652">
                    Nome
                  </label>
                  <input type="text" name="firstName" value={profile.firstName} onChange={handleProfileChange} className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none transition-all" data-id="element-653" />
                </div>
                <div className="space-y-1.5" data-id="element-654">
                  <label className="text-sm font-medium text-gray-700" data-id="element-655">
                    Cognome
                  </label>
                  <input type="text" name="lastName" value={profile.lastName} onChange={handleProfileChange} className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none transition-all" data-id="element-656" />
                </div>
                <div className="space-y-1.5 md:col-span-2" data-id="element-657">
                  <label className="text-sm font-medium text-gray-700" data-id="element-658">
                    Email
                  </label>
                  <input type="email" name="email" value={profile.email} onChange={handleProfileChange} className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none transition-all" data-id="element-659" />
                </div>
                <div className="space-y-1.5" data-id="element-660">
                  <label className="text-sm font-medium text-gray-700" data-id="element-661">
                    Telefono
                  </label>
                  <input type="tel" name="phone" value={profile.phone} onChange={handleProfileChange} className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none transition-all" data-id="element-662" />
                </div>
                <div className="space-y-1.5" data-id="element-663">
                  <label className="text-sm font-medium text-gray-700" data-id="element-664">
                    Azienda
                  </label>
                  <input type="text" name="company" value={profile.company} onChange={handleProfileChange} className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none transition-all" data-id="element-665" />
                </div>
                <div className="space-y-1.5 md:col-span-2" data-id="element-666">
                  <label className="text-sm font-medium text-gray-700" data-id="element-667">
                    Partita IVA
                  </label>
                  <input type="text" name="vat" value={profile.vat} onChange={handleProfileChange} className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none transition-all" data-id="element-668" />
                </div>
              </div>

              <div className="mt-8 flex justify-end" data-id="element-669">
                <button onClick={handleSave} className="bg-teal-deep text-white px-6 py-2.5 rounded-lg font-medium text-sm hover:bg-teal-deep/90 transition-colors shadow-sm flex items-center gap-2" data-id="element-670">
                  <Save size={16} data-id="element-671" />
                  Salva Modifiche
                </button>
              </div>
            </div>}

          {activeSection === 'proprieta' && <div className="bg-white border border-gray-200 rounded-xl p-6" data-id="element-672">
              <h2 className="text-lg font-bold text-navy mb-6" data-id="element-673">
                Proprietà Default
              </h2>
              <p className="text-sm text-gray-500 mb-6" data-id="element-674">
                Queste impostazioni verranno applicate automaticamente alle
                nuove proprietà create.
              </p>

              <div className="space-y-6" data-id="element-675">
                <div data-id="element-676">
                  <h3 className="text-sm font-bold text-navy mb-3" data-id="element-677">
                    Checklist Predefinita
                  </h3>
                  <div className="space-y-2" data-id="element-678">
                    {checklist.map(item => <label key={item.id} className="flex items-center gap-3 p-3 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors" data-id="element-679">
                        <div className={`w-5 h-5 rounded border flex items-center justify-center transition-colors ${item.checked ? 'bg-teal-deep border-teal-deep text-white' : 'bg-white border-gray-300'}`} data-id="element-680">
                          {item.checked && <Check size={14} data-id="element-681" />}
                        </div>
                        <input type="checkbox" checked={item.checked} onChange={() => toggleChecklist(item.id)} className="hidden" data-id="element-682" />
                        <span className="text-sm text-gray-700" data-id="element-683">
                          {item.label}
                        </span>
                      </label>)}
                  </div>
                </div>

                <div data-id="element-684">
                  <h3 className="text-sm font-bold text-navy mb-3" data-id="element-685">
                    Istruzioni Accesso Predefinite
                  </h3>
                  <textarea value={accessInstructions} onChange={e => setAccessInstructions(e.target.value)} placeholder="Inserisci qui le istruzioni standard per l'accesso (es. codice portone, cassetta di sicurezza...)" className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none min-h-[120px] resize-none" data-id="element-686" />
                </div>

                <div className="flex justify-end pt-4 border-t border-gray-100" data-id="element-687">
                  <button onClick={handleSave} className="bg-teal-deep text-white px-6 py-2.5 rounded-lg font-medium text-sm hover:bg-teal-deep/90 transition-colors shadow-sm flex items-center gap-2" data-id="element-688">
                    <Save size={16} data-id="element-689" />
                    Salva
                  </button>
                </div>
              </div>
            </div>}

          {activeSection === 'notifiche' && <div className="bg-white border border-gray-200 rounded-xl p-6" data-id="element-690">
              <h2 className="text-lg font-bold text-navy mb-4" data-id="element-691">
                Preferenze Notifiche
              </h2>

              <div className="space-y-4" data-id="element-692">
                <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-693">
                  <div data-id="element-694">
                    <p className="text-sm font-medium text-navy" data-id="element-695">
                      Nuove Esigenze
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-696">
                      Ricevi una notifica quando viene creata una nuova esigenza
                    </p>
                  </div>
                  <button onClick={() => toggleNotification('newRequests')} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${notifications.newRequests ? 'bg-teal-deep' : 'bg-gray-200'}`} data-id="element-697">
                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${notifications.newRequests ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-698" />
                  </button>
                </div>

                <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-699">
                  <div data-id="element-700">
                    <p className="text-sm font-medium text-navy" data-id="element-701">
                      Aggiornamenti Interventi
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-702">
                      Notifiche sullo stato degli interventi in corso
                    </p>
                  </div>
                  <button onClick={() => toggleNotification('updates')} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${notifications.updates ? 'bg-teal-deep' : 'bg-gray-200'}`} data-id="element-703">
                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${notifications.updates ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-704" />
                  </button>
                </div>

                <div className="flex items-center justify-between py-3" data-id="element-705">
                  <div data-id="element-706">
                    <p className="text-sm font-medium text-navy" data-id="element-707">
                      Riepilogo Settimanale
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-708">
                      Ricevi un report via email ogni lunedì mattina
                    </p>
                  </div>
                  <button onClick={() => toggleNotification('weeklyReport')} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${notifications.weeklyReport ? 'bg-teal-deep' : 'bg-gray-200'}`} data-id="element-709">
                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${notifications.weeklyReport ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-710" />
                  </button>
                </div>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}